module.exports = __webpack_public_path__ + "img/house-laptop.8ce1d52f.svg";